import {ModelViewersApi} from 'hemwb-api';
import {configuration} from '../getBackendConfiguration';

const modelViewersApi = new ModelViewersApi(configuration);

export const requestModelViewers = (modelUuid: string) => {
  if (!modelUuid) {
    return Promise.resolve([]);
  }
  return modelViewersApi.getModelViewers({modelUuid});
};
